//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'

import VueToastMixin from '~/mixins/plugins/vue-toastification'

import GTM from '~/utils/classes/Gtm'
import layout from '~/mixins/layout'
import RegisterModal from "~/components/modal/auth/register-modal.vue";
import LoginModal from "~/components/modal/auth/login-modal.vue";

export default {
  name: 'CampaignLayout',
  components: {
    LoginModal, RegisterModal,
    InfoBar: () => import('~/components/Header/InfoBar'),
    HeaderContainer: () => import('~/components/HeaderContainer'),
  },
  mixins: [VueToastMixin, layout],
  data () {
    return {
      gtm: new GTM(this.$gtm)
    }
  },
  computed: {
    ...mapState({
      loadCounters: 'useCounters'
    }),
    ...mapGetters({
      currentLanguage: 'lang/currentLanguage',
      locale: 'lang/locale'
    })
  }
}
